import axios from "infra/http";
import { useQuery } from "react-query";
import { ArrecadacaoDetalhesResponse } from "./typings";

function useArrecadacao(id?: string) {
  return useQuery(
    `/v1/arrecadacao/${id}`,
    async () => {
      if (!id) {
        return null;
      }
      const res = await axios.get<ArrecadacaoDetalhesResponse>(
        `/v1/arrecadacao/${id}`
      );

      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useArrecadacao;
